export default __webpack_public_path__ + "static/media/CX_loading_icon.d3b1992a.svg";